import { CircularProgress, Stack, Typography } from '@mui/material'

export const Loading = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', pt: '6rem', opacity: 0.6 }}
    >
      <CircularProgress />
      <Typography>Loading ...</Typography>
    </Stack>
  )
}
